<template>
    <el-table
            :data="tableData"
            style="width: 100%">
        <el-table-column
                label="信息" type="expand">
            <template slot-scope="props">
                <el-form label-position="left" inline class="demo-table-expand">
                    <el-form-item>
                        <el-tag style="margin:5px;" v-for="item in props.row.apply">{{ item }}</el-tag>
                    </el-form-item>
                </el-form>
            </template>
        </el-table-column>
        <el-table-column
                label="工种类别"
                prop="gzleibie"
                width="180">
        </el-table-column>
        <el-table-column
                label="工种项目"
                prop="gzxiangmu"
                width="180">
        </el-table-column>
        <el-table-column
                label="工种类型"
                prop="gzleixing"
                width="180">
        </el-table-column>
        <el-table-column
                label="数量"
                prop="buyNumber"
                width="180">
        </el-table-column>
        <el-table-column
                label="总价格"
                width="180">
            <template slot-scope="scope">
                <span>{{(scope.row.buyNumber * scope.row.gzprice) | format}}</span>
            </template>
        </el-table-column>
    </el-table>
</template>

<script>
    import axios from 'axios';

    export default {
        name: "paytable",
        props: ["indentdata"],
        computed: {
            cartCount() {
                return this.$store.state.cartCount;
            },
        },
        components: {
            axios,
        },
        data() {
            return {
                tableData: [],
                totalMoney: 0,
                totalNumber: 0,
            }
        },
        mounted() {

        },
        watch: {
            cartCount() {
                axios.post("/Api/admin/getOkPayData", {id: this.indentdata}).then(res => {
                    if (res.statusText == "OK") {
                        if (res.data.errcode == 0) {
                            this.tableData = res.data.data;
                            //计算商品总是和总金额
                            for (var num in this.tableData) {
                                this.totalMoney = this.totalMoney + (this.tableData[num].buyNumber * this.tableData[num].gzprice);
                                this.totalNumber = this.totalNumber + this.tableData[num].buyNumber;
                            }
                        }
                    }
                });
            }
        },
        filters: {  //数据过滤器
            format: function (value) {
                var _val;
                value = Number(value).toFixed(2);
                if (value == 0) {
                    value = 0;
                    return "￥ " + value + ".00";
                }
                _val = value.split('.');
                return '￥ ' + _val[0] + '.' + _val[1];
            },
        }
    }
</script>

<style>

</style>